// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__q9Y6s","bottom":"styles_bottom__sqQ5p","top":"styles_top__HpUlk","left":"styles_left__EqtD0","right":"styles_right__8S_Ej"};